export default "__VITE_ASSET__v$oyC0Tz__"